<template>
<div class="page-wrapper bind-wx-wrapper">
  <div class="bind-wx-content-wrapper content-wrapper">
    <div class="logo-wrapper">
      <van-image  fit="contain" width="200" height="100" :src="siteLogo" />
    </div>
    <van-form @submit="bindWx">
      <van-field
        v-model="phone"
        name="phone"
        label="手机号"
        placeholder="请输入手机号"
        :rules="[{ validator: phoneAsyncValidator }]"
      />
        <van-field
          v-model="sms"
          center
          clearable
          label="短信验证码"
          placeholder="请输入短信验证码"
          :rules="[{ required: true }]"
        >
          <template #button>
            <van-button @click="handleSmsSend" native-type="button" v-if="getCodeBtn" size="small" type="primary">发送验证码</van-button>
            <van-button disabled v-else  size="small" type="primary">重新发送&nbsp;&nbsp;&nbsp;&nbsp;{{count}}&nbsp;&nbsp;&nbsp;&nbsp;s</van-button>
          </template>
        </van-field>
      <van-field
        v-model="password"
        v-if="registerAndBind"
        type="password"
        name="password"
        label="密码"
        placeholder="请填写密码"
        :rules="[{ required: true }]"
      />
      <van-field
        v-model="confirmPassword"
        v-if="registerAndBind"
        type="password"
        name="password"
        label="确认密码"
        :placeholder="password ? '确认密码和密码不一致' : '请填写密码'"
        :rules="[{ validator: confirmPasswordValidator}]"
      />
      <div v-if="bind" style="margin: 16px;">
        <van-button round block type="info" native-type="submit">
          确认绑定
        </van-button>
      </div>
      <div v-if="registerAndBind" style="margin: 16px;">
        <van-button round block type="info" native-type="submit">
          确认注册并绑定微信
        </van-button>
      </div>
    </van-form>
  </div>

    <van-action-sheet
      v-model="actionSelectShow"
      :actions="actions"
      description="绑定成功,接下来您想要"
      close-on-click-action
      @select="handleActionSelect"
    />
</div>
</template>

<script>
import { Toast, Dialog } from 'vant';
import store from '@/store/index'
export default {
  computed:{
    siteLogo() {
          return require('@/assets/logo/logo.png')
      },
  },
  created(){
      console.log(this.$route)
      const query = this.$route.query
      if(query.openId){
          this.openId = query.openId
      }
  },
  data() {
    return {
      getCodeBtn: true,
      sms: '',
      count: 0,
        registerAndBind:false,
        bind: false,
      openId: '',
      actions: [
        { name: '订单查询', action: 'toOrder' },
        { name: '报告查询', action: 'toReport'  },
        { name: '报告验证', action: 'toReportValid'  },
      ],
      actionSelectShow: false,
      phone: '',
      password: '',
      confirmPassword: '',
      btnDisable:{
        login: false,
      },
    };
  },
  methods: {
    bindWx(){
      const _this = this
      const type = this.bind ? 'bind' : 'register'
      _this.$post('/wexin/bindWx?type=' + type,{
        phone: _this.phone,
        password: _this.password,
        validCode: _this.sms,
        openId: _this.openId
      }).then(res => {
        if(res.data.success){
          const data  = res.data.data
          store.commit('account/setAccessToken', data.access_token);
          store.commit('account/setRefreshToken', data.refresh_token);
          const current = new Date();
          const expireTime = current.setTime(current.getTime() + 1000 * data.expire_in);
          store.commit('account/setExpireTime', expireTime);
          store.commit('account/setUser', data.user_info);
          _this.actionSelectShow = true
        }else{
              Dialog.alert({
                title: '提示',
                message: res.data.msg ? res.data.msg: '请联系管理员',
              }).then(() => {
                // on close
              });
        }

      }).catch(error => {

      }).finally(()=> {

      })

    },
    handleSmsSend(){
      const TIME_COUNT = 60;
      const _this = this
      if(!_this.phone){
            Toast.fail({
              position: 'bottom',
              message: '请先填写手机号码'
            })
            return
      }
      if (!_this.timer) {
          _this.count = TIME_COUNT;
          _this.getCodeBtn = !_this.getCodeBtn
          _this.$post('/auth/sendSms',{ phone: _this.phone, type:'register'})
          .then(r =>{
                    console.log(r)
              if (r.data.success){
                 Toast.success({
                    position: 'bottom',
                    message: '验证码已发送 请注意查收'
                  })
              }else {
                   console.log('失败')
      
                  Toast.fail({
                    position: 'bottom',
                    message: '验证码发送出错 请重试'
                  })
              }
          })
          .catch(e =>{
            console.log('出错')
            console.log(e)
                 Toast.fail({
                    position: 'bottom',
                    message: '验证码发送出错 请重试'
                  })
          }).finally(()=>{

          });
          _this.timer = setInterval(() => {
              if (_this.count > 0 && _this.count <= TIME_COUNT) {
                  _this.count--;
              } else {
                  _this.getCodeBtn = !_this.getCodeBtn
                  clearInterval(_this.timer);
                  _this.timer = null;
              }
          }, 1000)
      }
    },
    confirmPasswordValidator(val) {
      return this.password && this.confirmPassword === this.password;
    },
          // 异步校验函数返回 Promise
    phoneAsyncValidator(val) {
        const _this = this
      return new Promise((resolve) => {
        if(val === ''){
          resolve(false)
        }else{
          Toast.loading('验证中...');
          _this.$get('/auth/phone/valid/' + val).then(res =>{
                  if (res.data.success){
                      console.log('绑定')
                      _this.bind = true
                      _this.registerAndBind = false
                  }else {
                        _this.bind = false
                      _this.registerAndBind = true
                  }
              }).finally(() => {
                  resolve()
              })
        }
      });
    },
    onSubmit(values) {
      console.log('submit', values);
      const _this = this;
      _this.btnDisable.login = true

      _this.$post('/auth/token',{phone: _this.phone, password: _this.password}).then((r) => {
          _this.saveLoginData(r.data.data);
          _this.actionSelectShow = true
      }).catch(e => {
          console.log('error')
          console.log(e)
      }).finally(() => {
          _this.btnDisable.login = false
      })
    },
    saveLoginData(data){
        store.commit('account/setAccessToken', data.access_token);
        store.commit('account/setRefreshToken', data.refresh_token);
        const current = new Date();
        const expireTime = current.setTime(current.getTime() + 1000 * data.expire_in);
        store.commit('account/setExpireTime', expireTime);
        store.commit('account/setUser', data.user_info);
    },
    handleActionSelect(action, index){
      this[this.actions[index].action]()
    },
    toOrder(){
      this.$router.push('order')
    },
    toReport(){
      this.$router.push('report')
    },
    toRportValid(){
      this.$router.push('repirtValid')
    }
  },
};
</script>

<style lang="scss">
.logo-wrapper{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.bind-wx-content-wrapper{
  margin-top: 20px;
}
</style>
